import React from "react";

const thumbStyle = {
  width: 48,
  height: 48,
  objectFit: "cover",
  borderRadius: 4,
};

/** @param {(key: string) => string} tk */
export function getProductColumns(tk) {
  return [
    {
      key: "image_url",
      label: tk("columns.image"),
      render: (row) =>
        row.image_url ? (
          <img src={row.image_url} alt="" style={thumbStyle} />
        ) : (
          tk("table.emptyCell")
        ),
    },
    { key: "name_en", label: tk("columns.nameEn") },
    { key: "name_ar", label: tk("columns.nameAr") },
    { key: "category_label", label: tk("columns.category") },
    {
      key: "is_featured",
      label: tk("columns.featured"),
      render: (row) =>
        row.is_featured ? tk("table.featuredYes") : tk("table.emptyCell"),
    },
    { key: "gallery_count", label: tk("columns.gallery") },
  ];
}
